import { User } from "types";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "~/apis/requests/useApiCall";
import { Branch } from "~/types/branch";

export const useBranchStore = definePiniaStore("useBranchStore", {
  state: () => ({
    _branches: [] as Branch[],
    _selectedBranchForEdit: {} as Branch,
    _branch: {} as Branch,
    showEditModal: false,
    showCreateModal: false,
  }),
  getters: {
    branches: (state) => state._branches,
    selectedBranchForEdit: (state) => state._selectedBranchForEdit,
    branch: (state) => state._branch,
  },
  actions: {
    async getBranch(branchId: number) {
      const { response, error } = await getRequest<Branch>(
        `/branches/${branchId}`
      );
      if (!error) {
        this.$state._branch = response.data;
      }
    },
    async createBranch(branch: Branch) {
      const { response, error } = await postRequest<Branch>(
        "/branches",
        branch
      );
      if (!error) {
        return response;
      }
      return null;
    },
    async updateBranch(branch: Branch) {
      const { response, error } = await putRequest<Branch>(
        `/branches/${branch.id}`,
        branch
      );
      if (!error) {
        return response.data;
      }
      return null;
    },
    async deleteBranch(branch: Branch) {
      return await deleteRequest(`/branches/${branch.id}`);
    },

    async getBranchCollection() {
      const { response, error } = await getRequest<Branch[]>("/branches");
      if (!error) {
        this.$state._branches = response.data;
      }
      return [];
    },
  },
});
